import { useState, useEffect } from 'react';

// This is a hook that returns the JWT token from the session storage
// or can be used to set/remove the JWT token in the session storage
const useJWT = () => {
  const [token, setToken] = useState(sessionStorage.getItem('access-token'));

  const setJWT = (newToken) => {
    if (newToken) {
      sessionStorage.setItem('access-token', newToken);
    } else {
      sessionStorage.removeItem('access-token');
    }
    setToken(newToken);
  };

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'access-token') {
        setToken(sessionStorage.getItem('access-token'));
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return [token, setJWT];
};

export default useJWT;